import { useEffect, useState } from 'react'
import { ArcProgressBarProps } from './types'
import { useTheme } from '@/hooks/useTheme'

export const AnimatedArcProgressSVG = ({
  percentage,
  size,
  strokeWidth,
  color,
  backgroundColor,
}: Omit<ArcProgressBarProps, 'size' | 'strokeWidth'> & {
  size: number
  strokeWidth: number
}) => {
  const theme = useTheme()
  const [animatedValue, setAnimatedValue] = useState(0)

  const halfSize = size / 2

  useEffect(() => {
    // Reset animation
    setAnimatedValue(0)

    // Start animation after a short delay
    const timer = setTimeout(() => {
      // Если percentage уже в диапазоне 0-1, используем как есть
      // Если в диапазоне 0-100, делим на 100
      const normalizedPercentage =
        percentage > 1 ? percentage / 100 : percentage
      setAnimatedValue(normalizedPercentage)
    }, 100)

    return () => clearTimeout(timer)
  }, [percentage])

  // Расчеты для полукруглой дуги сверху
  const radius = (size - strokeWidth * 2) / 2
  const circumference = Math.PI * radius
  const strokeDashoffset = circumference * (1 - animatedValue)

  // Создаем полукруглую дугу сверху (от левого края до правого через верх)
  const centerX = halfSize
  const centerY = halfSize
  const startX = strokeWidth
  const startY = centerY
  const endX = size - strokeWidth
  const endY = centerY
  const d = `M ${startX} ${startY} A ${radius} ${radius} 0 0 1 ${endX} ${endY}`

  return (
    <svg
      width={size}
      height={size}
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
      }}
    >
      {/* Background Arc */}
      <path
        d={d}
        stroke={
          backgroundColor ||
          theme.colors.background.arcProgressBackground ||
          '#333'
        }
        strokeWidth={strokeWidth}
        fill="none"
        strokeLinecap="round"
      />
      {/* Animated Arc */}
      <path
        d={d}
        stroke={color || theme.colors.background.arcProgressFill || '#8B5CF6'}
        strokeWidth={strokeWidth}
        fill="none"
        strokeDasharray={circumference}
        strokeDashoffset={strokeDashoffset}
        strokeLinecap="round"
        style={{
          transition: 'stroke-dashoffset 1s cubic-bezier(0.4, 0, 0.2, 1)',
        }}
      />
    </svg>
  )
}
